import React from 'react';
import Datetime from 'react-datetime';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import cn from 'classnames';
import { CONSTANTS } from 'components/shared/constants';
import { DateType } from 'global.interfaces';
import { Attributes, FormType, GetAttributesType } from './formField.interface';

interface IProps {
  name: string;
  title: string;
  tooltip?: string;
  attributes?: Attributes;
  getAttributes?: GetAttributesType;
  valid: boolean;
  validationMessage: string;
  form?: FormType;
  dateFormat?: string;
  timeFormat?: boolean;
  isValidDate?: () => boolean;
  utc?: boolean;
  required?: boolean;
  closeOnSelect?: boolean;
  onChange: (name: string, value: DateType) => void;
  value: string;
}

class DatetimePicker extends React.Component<IProps> {
  onChange = (value: DateType) => {
    this.props.onChange(this.props.name, value);
  };

  render() {
    const {
      title,
      tooltip,
      attributes,
      getAttributes,
      valid,
      validationMessage,
      form,
      dateFormat,
      timeFormat,
      isValidDate = () => true,
      utc = true,
      required,
      closeOnSelect,
      name,
    } = this.props;
    const { DATE_FORMAT, TIME_FORMAT } = CONSTANTS;
    const attr = getAttributes ? { ...attributes, ...getAttributes(form) } : attributes;
    const className = cn('form__input', { invalid: !valid });

    const currentDateFormat = dateFormat != null ? dateFormat : DATE_FORMAT;
    const currentTimeFormat = timeFormat != null ? timeFormat : TIME_FORMAT;

    return (
      <InputFieldWrapper
        name={name}
        title={title}
        tooltip={tooltip}
        valid={valid}
        validationMessage={validationMessage}
        required={required}>
        <Datetime
          value={this.props.value}
          inputProps={{
            className,
            ...attr,
          }}
          utc={utc}
          dateFormat={currentDateFormat}
          timeFormat={currentTimeFormat}
          onChange={this.onChange}
          isValidDate={isValidDate}
          closeOnSelect={closeOnSelect}
        />
      </InputFieldWrapper>
    );
  }
}

export default DatetimePicker;
